import { ItemSupportEmail } from './support-email.model';
import { TYPE_FILE } from '../enums/data-mock-enums';

export enum APPLICATION_TRAINING_DOCUMENT_FE_BE_MAPPING_FIELD {
    id = 'id',
    name = 'name',
    thumbnail = 'thumbnail',
    active = 'active',
    emails = 'emails',
    materials = 'materials',

    type = 'type',
    url = 'url',
    materialName = 'name',
    resource = 'resource',

    resourceId = 'resourceId',
    resourceName = 'resourceName',
    resourceUrl = 'resourceUrl',
}
export class ApplicationTrainingDocument {
    id: number;
    name: string;
    thumbnail: Resource;
    active: boolean;
    materials: MaterialApplicationTrainingDocument[];
    emails: ItemSupportEmail[];

    constructor(params: any = {}, parsed: boolean = true) {

        if (parsed) {
            this.parseFromResp(params);
        } else {
            this.id = params.id;
            this.name = params.name;
            this.thumbnail = params.thumbnail ? new Resource(params.thumbnail, false) : null;
            this.active = params.active || true;
            this.materials = (params.materials || []).map((material) => new MaterialApplicationTrainingDocument(material, false));
            this.emails = (params.emails || []).map((email) => new ItemSupportEmail(email, false));
        }
    }

    parseFromResp(respObject: any = {}) {
        this.id = respObject[APPLICATION_TRAINING_DOCUMENT_FE_BE_MAPPING_FIELD.id];
        this.name = respObject[APPLICATION_TRAINING_DOCUMENT_FE_BE_MAPPING_FIELD.name];
        this.active = respObject[APPLICATION_TRAINING_DOCUMENT_FE_BE_MAPPING_FIELD.active];
        const thumbnail = respObject[APPLICATION_TRAINING_DOCUMENT_FE_BE_MAPPING_FIELD.thumbnail];
        if (thumbnail) {
            this.thumbnail = new Resource(thumbnail);
        }
        this.materials = (respObject[APPLICATION_TRAINING_DOCUMENT_FE_BE_MAPPING_FIELD.materials] || [])
            .map((material) => {
                return new MaterialApplicationTrainingDocument(material);
            });
        this.emails = (respObject[APPLICATION_TRAINING_DOCUMENT_FE_BE_MAPPING_FIELD.emails] || [])
            .map((email) => {
                return new ItemSupportEmail(email);
            });
        return this;
    }

    convertToReqBody() {
        const body = {};
        body[APPLICATION_TRAINING_DOCUMENT_FE_BE_MAPPING_FIELD.id] = this.id;
        body[APPLICATION_TRAINING_DOCUMENT_FE_BE_MAPPING_FIELD.active] = this.active;
        body[APPLICATION_TRAINING_DOCUMENT_FE_BE_MAPPING_FIELD.thumbnail] = this.thumbnail
        ? this.thumbnail.convertToReqBody() : null;
        body[APPLICATION_TRAINING_DOCUMENT_FE_BE_MAPPING_FIELD.name] = this.name || '';
        body[APPLICATION_TRAINING_DOCUMENT_FE_BE_MAPPING_FIELD.materials] = (this.materials || [])
            .map((material: MaterialApplicationTrainingDocument) => {
                const materialBody = material.convertToReqBody();
                return materialBody;
            });
        body[APPLICATION_TRAINING_DOCUMENT_FE_BE_MAPPING_FIELD.emails] = (this.emails || [])
            .map((email: ItemSupportEmail) => {
                const itemBody = email.convertToReqBody();
                return itemBody;
            });
        return body;

    }
}
export class MaterialApplicationTrainingDocument {
    id: number;
    materialName: string;
    type: string;
    url: string;
    resource: Resource;
    name: string;

    constructor(params: any = {}, parsed: boolean = true) {

        if (parsed) {
            this.parseFromResp(params);
        } else {
            this.id = params.id;
            this.type = params.type;
            this.url = params.url;
            this.resource = params.resource ? new Resource(params.resource, false) : null;
            this.materialName = params.materialName;
            this.type = params.type;
        }
    }

    parseFromResp(respObject: any = {}) {
        this.id = respObject[APPLICATION_TRAINING_DOCUMENT_FE_BE_MAPPING_FIELD.id];
        this.type = respObject[APPLICATION_TRAINING_DOCUMENT_FE_BE_MAPPING_FIELD.type] === TYPE_FILE.DOCUMENT
            ? TYPE_FILE.KEY_DOCUMENT : TYPE_FILE.KEY_VIDEO;
        this.url = respObject[APPLICATION_TRAINING_DOCUMENT_FE_BE_MAPPING_FIELD.url];
        this.materialName = respObject[APPLICATION_TRAINING_DOCUMENT_FE_BE_MAPPING_FIELD.materialName];
        const resource = respObject[APPLICATION_TRAINING_DOCUMENT_FE_BE_MAPPING_FIELD.resource];
        if (resource) {
            this.resource = new Resource(resource);
        }
        return this;
    }

    convertToReqBody() {
        const body = {};
        body[APPLICATION_TRAINING_DOCUMENT_FE_BE_MAPPING_FIELD.id] = this.id;
        body[APPLICATION_TRAINING_DOCUMENT_FE_BE_MAPPING_FIELD.materialName] = this.materialName;
        body[APPLICATION_TRAINING_DOCUMENT_FE_BE_MAPPING_FIELD.type] = this.type === TYPE_FILE.KEY_DOCUMENT
            ? TYPE_FILE.DOCUMENT : TYPE_FILE.VIDEO;
        body[APPLICATION_TRAINING_DOCUMENT_FE_BE_MAPPING_FIELD.url] = this.url || '';
        body[APPLICATION_TRAINING_DOCUMENT_FE_BE_MAPPING_FIELD.resource] = this.resource
        ? this.resource.convertToReqBody() : null;
        return body;

    }
}
export class Resource {
    id: number;
    resourceId: string;
    resourceName: string;
    resourceUrl: string;

    constructor(params: any = {}, parsed: boolean = true) {

        if (parsed) {
            this.parseFromResp(params);
        } else {
            this.id = params ? params.id : null;
            this.resourceId = params ? params.resourceId : '';
            this.resourceName = params ? params.resourceName : '';
            this.resourceUrl = params ? params.resourceUrl : '';
        }
    }

    parseFromResp(respObject: any = {}) {
        this.id = respObject[APPLICATION_TRAINING_DOCUMENT_FE_BE_MAPPING_FIELD.id];
        this.resourceId = respObject[APPLICATION_TRAINING_DOCUMENT_FE_BE_MAPPING_FIELD.resourceId] || '';
        this.resourceName = respObject[APPLICATION_TRAINING_DOCUMENT_FE_BE_MAPPING_FIELD.resourceName] || '';
        this.resourceUrl = respObject[APPLICATION_TRAINING_DOCUMENT_FE_BE_MAPPING_FIELD.resourceUrl] || '';
        return this;
    }

    convertToReqBody() {
        const body = {};
        body[APPLICATION_TRAINING_DOCUMENT_FE_BE_MAPPING_FIELD.id] = this.id;
        body[APPLICATION_TRAINING_DOCUMENT_FE_BE_MAPPING_FIELD.resourceId] = this.resourceId || '';
        body[APPLICATION_TRAINING_DOCUMENT_FE_BE_MAPPING_FIELD.resourceName] = this.resourceName || '';
        // body[APPLICATION_TRAINING_DOCUMENT_FE_BE_MAPPING_FIELD.resourceUrl] = this.resourceUrl || '';
        return body;

    }
}
